import { useEffect, useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import Api from "../../../../../constants/Api";

// Iniciais do colaborador para quando não há foto: primeira letra do primeiro e do último nome.
export const getInitials = (name) => {
    if (!name) return "??";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/**
 * Foto do colaborador, buscada do cadastro em base64, com as iniciais quando não há foto.
 *
 * Compartilhada pelo painel de Desempenho e pela análise individual. A imagem vem como
 * data URI de propósito: o PDF da análise é uma cópia da página, e um endereço que dependesse
 * do login não carregaria na cópia; o conteúdo embutido vai junto.
 */
const EmployeeAvatar = ({ employeeId, name }) => {
    const [imgData, setImgData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (employeeId) {
            setLoading(true);
            setImgData(null);
            axiosInstance.get(`${Api.main.employee}/download/base64/${employeeId}`)
                .then(resp => {
                    if (resp.data) {
                        setImgData(`data:image/jpeg;base64,${resp.data}`);
                    }
                })
                .catch(err => console.error("Error loading avatar", err))
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [employeeId]);

    if (loading) {
        return (
            <div className="employee-performance-card__avatar-spinner">
                <i className="fas fa-circle-notch fa-spin"></i>
            </div>
        );
    }

    if (imgData) {
        return (
            <img
                src={imgData}
                alt={name}
                className="employee-performance-card__avatar"
            />
        );
    }

    return (
        <div className="employee-performance-card__avatar-fallback">
            {getInitials(name)}
        </div>
    );
};

export default EmployeeAvatar;
